import { marked } from "marked";

export const fileName = (url) => {
  return new URL(url).pathname.split("/").pop();
};

export const getFileType = (fileName) => {
  if (!fileName) return "Unknown"; // Handle empty values
  return fileName.split(".").pop().toUpperCase(); // Extract and format extension
};

export const createShortNameFile = (file_url) => {
  if (!file_url || file_url == null) {
    return "N/A";
  } else {
    // file_url = fileName(file_url);
    // // Decode the URL-encoded name
    // const decodedName = decodeURIComponent(file_url.split("_")[1]);

    // // Separate the name and extension
    // const extensionIndex = decodedName.lastIndexOf(".");
    // const namePart = decodedName.substring(0, extensionIndex);
    // const extension = decodedName.substring(extensionIndex);

    // // Truncate the name part and add the extension back
    // const shortName =
    //   namePart.length > 20
    //     ? namePart.substring(0, 20) + "..." + extension
    //     : decodedName;

    // return shortName;
    // Extract the file name from the URL (last part after the last '/')
    // Extract the file name from the URL (last part after the last '/')
    const fileName = file_url.substring(file_url.lastIndexOf("/") + 1);

    // Find the last period in the name for the extension
    const extensionIndex = fileName.lastIndexOf(".");

    // Extract the name part and the extension
    let namePart, extension;
    if (extensionIndex !== -1) {
      namePart = fileName.substring(0, extensionIndex);
      extension = fileName.substring(extensionIndex);
    } else {
      // If no extension exists, treat the whole as the name part
      namePart = fileName;
      extension = "";
    }

    // Truncate the name part and add the extension back
    const shortName =
      namePart.length > 20
        ? namePart.substring(0, 20) + "..." + extension
        : namePart + extension;

    return shortName;
  }
};

export const createShortNameFileDoc = (file_url) => {
  if (!file_url || file_url == null) {
    return "N/A";
  } else {
    const fileName = file_url.substring(file_url.lastIndexOf("/") + 1);

    // Find the last period in the name for the extension
    const extensionIndex = fileName.lastIndexOf(".");

    // Extract the name part and the extension
    let namePart, extension;
    if (extensionIndex !== -1) {
      namePart = fileName.substring(0, extensionIndex);
      extension = fileName.substring(extensionIndex);
    } else {
      // If no extension exists, treat the whole as the name part
      namePart = fileName;
      extension = "";
    }

    // Truncate the name part and add the extension back
    const shortName =
      namePart.length > 10
        ? namePart.substring(0, 15) + "..." + extension
        : namePart + extension;

    return shortName;
  }
}

export const textRetriever = (text) => {
  if (!text || text == null) {
    return "N/A";
  } else {
    return text;
  }
};

export const textRetrieverTextArea = (rawText)=>{
  if ( rawText!='' ) {
    return rawText.replace(/\n/g, "<br>");
  }
  return '';
}


export const errorMessageCreate = (error) => { 
  if (Array.isArray(error)) {
    return error[0];
  } else if (typeof error === 'string') {
    return error;
  } else {
    return "something went wrong";
  }
}

export function safeMarkedWrapper(input) {
  if (typeof input !== 'string') {
      console.warn(`marked(): Received non-string input:`, input);
      return '';
  }
  return marked(input);
}

export const convertImageToBase64 = (imagePath) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous"; // Avoid CORS issues for external images
    img.src = imagePath;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(img, 0, 0);
      const base64String = canvas.toDataURL("image/png"); // Convert to Base64
      resolve(base64String);
    };

    img.onerror = (error) => reject(error); // Handle errors
  });
};

export const reportDateDwonaloadDateFormat = () => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = now.getFullYear();
  return `${day}_${month}_${year}`;
};